import React from 'react'
import { Container } from './styles'
function NotFound() {
  return <Container>404 NOT FOUND</Container>
}
export default NotFound
